import { BonusUi, ImageCropper } from "../../../Constant";
import { Breadcrumbs } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import ImageCropperBody from "./ImageCropperBody";

export default function ImageCropperContainer() {
  return (
    <>
      <Breadcrumbs title={ImageCropper} parent={BonusUi} pageTitle={ImageCropper} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={ImageCropper} />
              <CardBody>
              <ImageCropperBody />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
